var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',_vm._g(_vm._b({attrs:{"type":_vm.type,"value":_vm.value},on:{"change":_vm.handleChange}},'el-date-picker',_vm.computedAttrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }